import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class ScriptLoaderService {
  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script ${src}`));
      document.body.insertBefore(script, document.body.firstChild);
    });
  }
}
